import { render, staticRenderFns } from "./BillingDocs.vue?vue&type=template&id=4706b614&scoped=true"
import script from "./BillingDocs.vue?vue&type=script&lang=js"
export * from "./BillingDocs.vue?vue&type=script&lang=js"
import style0 from "./BillingDocs.vue?vue&type=style&index=0&id=4706b614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706b614",
  null
  
)

export default component.exports